import { observer } from 'mobx-react-lite';
import { useEnabledFeatures } from '../../../common/hooks/enabled-features/use-enabled-features';
import { useEventMetadataStore } from '../../event-panel-form/event-metadata';
import { EventPanelTab, EventPanelTabConfig } from './event-panel-tabs-config';
import { TabList, Tabs } from '@cad-arc';
import { TabHeader } from './tab-header';
import { getEventPanelTabTooltip } from '../../../common/helpers/get-usx-labels';

export const TabHeaders = observer(function TabHeaders({
    activeTab,
    tabConfigs,
}: {
    activeTab?: EventPanelTab;
    tabConfigs: EventPanelTabConfig[];
}) {
    const eventMetadata = useEventMetadataStore().state.metadata;
    const enabledFeatures = useEnabledFeatures();
    const tabsToShow = tabConfigs.filter((tabConfig) => {
        if (typeof tabConfig.checkEnabled === 'undefined') return true;
        return tabConfig.checkEnabled(enabledFeatures, eventMetadata);
    });

    // Because of the addition of the involved property tab, there are now 13 tab buttons
    // that can be visible in the event panel. Because the panel was built for 12, this causes
    // The event log tab to be hidden from view.
    // In order to keep the button within view in the event of the involved property tab
    // being enabled in RMS admin settings, the width of each tab button had to be reduced.
    const tabHeaderWidth = tabsToShow.length > 12 ? '2.4rem' : 'max-content';

    return (
        <Tabs
            loop={false}
            isManual={true}
            value={activeTab}
            style={{
                width: '100%',
                backgroundColor: 'var(--arc-colors-surface-foreground)',
                zIndex: 5,
            }}
        >
            <TabList
                style={{
                    borderBottom: 'none',
                    borderTop: 'solid 1px var(--arc-colors-border-default)',
                    width: '100%',
                    overflowX: 'hidden',
                }}
            >
                {tabsToShow.map((tabConfig) => (
                    <TabHeader
                        key={tabConfig.type}
                        value={tabConfig.type}
                        leadingVisual={tabConfig.icon}
                        tooltip={getEventPanelTabTooltip(
                            tabConfig.name,
                            enabledFeatures.dexNextEnabled
                        )}
                        errorFields={tabConfig.errorFields}
                        notificationTypes={
                            'notificationTypes' in tabConfig
                                ? tabConfig.notificationTypes
                                : undefined
                        }
                        tabHeaderWidth={tabHeaderWidth}
                        notificationsEntityTypes={
                            'notificationsEntityTypes' in tabConfig
                                ? tabConfig.notificationsEntityTypes
                                : undefined
                        }
                    />
                ))}
            </TabList>
        </Tabs>
    );
});
